<div class="column-layout-container">
  <div class="menu animate-in-from-left" [class.mobile-shown]="appService.mobileMenuShown">
    <aside role="region" aria-label="side navigation">
      <div class="menu-top d-flex justify-content-between align-items-center mb-0">
        <fui-heading [text]="'sphere.workspaces.workspaces' | translate" [level]="5"></fui-heading>
        <div>
          <button class="fa-button m-r-10" placement="bottom" [ngbTooltip]="'sphere.workspaces.add' | translate" (click)="add()">
            <fa-icon icon="plus" class="action create-action circle-icon-btn" aria-hidden="true"></fa-icon>
            <span class="sr-only">add</span>
          </button>
          <button
            class="fa-button m-r-10"
            placement="bottom"
            [ngbTooltip]="(refreshing ? 'general.refreshing_dots' : 'sphere.workspaces.refresh') | translate"
            (click)="refresh()"
            aria-label="refresh list"
          >
            <fa-icon icon="sync" class="action refresh circle-icon-btn" [animation]="refreshing ? 'spin' : undefined" aria-hidden="true"></fa-icon>
            <span class="sr-only">refresh</span>
          </button>
        </div>
      </div>

      @if (!loading && !workspaces.length && !collabs.length) {
        <div class="m-y-20 m-t-10">{{ "newdash.no_workspaces" | translate }}</div>
      }
      <nav class="nav flex-column" aria-label="side menu">
        @if (invites && invites.length) {
          <ul class="menu-options">
            <li class="menu-option detailed" [class.active]="!selectedID">
              <a class="primary-option" (keyup.enter)="appService.mobileMenuShown = false; showInvitations()" (click)="appService.mobileMenuShown = false; showInvitations()">
                <div class="d-flex">
                  <div>
                    <span class="title">{{ "sphere.workspaces.invitations" | translate }}</span>
                    <br />
                    <span class="extra-info">{{ "sphere.workspaces.workspaces_i_am_invited_to" | translate }}</span>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        }
        @if (loading) {
          <div class="m-t-20">
            <myp-skeleton-loader number="8" type="workspace-list-item"></myp-skeleton-loader>
          </div>
        }
        @if (workspaces && workspaces.length) {
          <h2 class="menu-option-header">{{ "sphere.workspaces.my_workspaces" | translate }}</h2>
          <ul class="menu-options">
            @for (item of workspaces; track item) {
              <li class="menu-option detailed" [class.active]="item.id == selectedID">
                <a
                  class="primary-option"
                  tabindex="0"
                  href="javascript:void(0);"
                  (keyup.enter)="appService.mobileMenuShown = false; selectWorkspace(item.id, item.name)"
                  (keyup.space)="appService.mobileMenuShown = false; selectWorkspace(item.id, item.name); $event.preventDefault()"
                  (click)="appService.mobileMenuShown = false; selectWorkspace(item.id, item.name)"
                >
                  <div class="d-flex">
                    <img class="image-border" [class.dark-image-bg]="!item.image" [src]="item.image || './assets/icons/workspace.png'" alt="" />
                    <div>
                      <span class="title">{{ item.name }}</span>
                      <br />
                      <span class="extra-info">{{ "general.created" | translate }}: {{ item.date_created | date }}</span>
                    </div>
                  </div>
                </a>
              </li>
            }
          </ul>
        }

        @if (collabs && collabs.length) {
          <h2 class="menu-option-header">{{ "sphere.workspaces.my_collabs" | translate }}</h2>
          <ul class="menu-options">
            @for (item of collabs; track item) {
              <li class="menu-option detailed" [class.active]="item.id == selectedID">
                <a
                  class="primary-option"
                  tabindex="0"
                  href="javascript:void(0);"
                  (keyup.enter)="appService.mobileMenuShown = false; selectWorkspace(item.id, item.name)"
                  (keyup.space)="appService.mobileMenuShown = false; selectWorkspace(item.id, item.name); $event.preventDefault()"
                  (click)="appService.mobileMenuShown = false; selectWorkspace(item.id, item.name)"
                >
                  <div class="d-flex">
                    <img class="image-border" [class.dark-image-bg]="!item.image" [src]="item.image || './assets/icons/collaboration.png'" alt="" />
                    <div>
                      <span class="title">{{ item.name }}</span>
                      <br />
                      <span class="extra-info">{{ "general.created" | translate }}: {{ item.date_created | date }}</span>
                    </div>
                  </div>
                </a>
              </li>
            }
          </ul>
        }
      </nav>
    </aside>
  </div>
  <section class="content animate-in-from-right" [class.mobile-shown]="!appService.mobileMenuShown" aria-label="workspace">
    <div class="mobile-back-btn" (click)="appService.mobileMenuShown = true">
      <fa-icon icon="chevron-left"></fa-icon>
      {{ "sphere.workspaces.workspaces" | translate }}
    </div>
    @if (selectedID && !loading) {
      <div class="content-constrained">
        <myp-shared-workspace-detail></myp-shared-workspace-detail>
      </div>
    } @else {
      @if (user.active_subscription) {
        <div class="w-full h-full d-flex justify-content-center align-items-center">
          <div>
            <span class="d-block m-b-20 text-center">{{ "newdash.no_workspace_selected" | translate }}</span>
            <myp-inline-loader [loading]="loadingInvites" height="200px" spinnerName="workspacesLoader2"></myp-inline-loader>
            <myp-collaboration-invite-notice (gotInvites)="gotInvites($event)"></myp-collaboration-invite-notice>
          </div>
        </div>
      }
      @if (!user.active_subscription) {
        <div class="row h-100">
          <div class="col h-100">
            <div class="h-100 d-flex justify-content-center align-items-center">
              <div style="max-width: 600px; margin: 10px">
                <myp-collaboration-invite-notice></myp-collaboration-invite-notice>
                <div>
                  <fui-heading [text]="'sphere.workspaces.empty_state_title' | translate" fontSize="f7" level="1"></fui-heading>
                </div>
                <p class="m-t-20">
                  {{ "newdash.workspaces_slug" | translate }}
                </p>
                <button class="btn btn-primary" (click)="workspacesVideo()">{{ "newdash.learn_more" | translate }}</button>
                &nbsp;&nbsp;&nbsp;
                <button class="btn btn-primary" (click)="add()">{{ "newdash.upgrade_to_sphere" | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      }
    }
  </section>
</div>
